import React from "react";
import MatchOfTheDayWrapper from "../../components/matchOfTheDayWrapper";
import Config from "../../../config/main";
import {t} from "../../../helpers/translator";
import {Link} from "react-router";
import FavoriteCompetitions from "../../components/favorteCompetitions";
import PopularSports from '../../components/popularSports';
import SecondPopularSports from "../../components/secondPopularSports";
import NextRacing from "../../components/nextRacing";
import FavoriteCompetitionsSlider from "../../components/favoriteCompetitionsSlider";

export default function home2Template () {
    return <div className={`terminal-home v-${Config.homePageView}`}>
        <div className="popular-sports-w">
            <div className="title-f-games-r">
                <h2>Popular Games</h2>
            </div>
            <div className="sports-p-list">
                <PopularSports/>
                { Config.nextRacingEnabled && <NextRacing sportId={184} size="big"/> }
                { Config.nextRacingEnabled && <NextRacing sportId={31} size="big"/> }
                {Config.enableTopGames && <Link className="TopGames" to="#"><i>Top games</i></Link>}
            </div>
        </div>
        {Config.homePageView === 5 ? (
            <div className="live-now-menu">
            <div className="menu-list-v">
                <SecondPopularSports/>
            </div>
                <div className="live-contain-baner">
                    <div className="live-icon-v">
                        <Link to={"/live"}>
                            Live Now
                        </Link>
                    </div>
                </div>

        </div>) : (<div className="featured-games-w">
                <MatchOfTheDayWrapper/>
            </div>)
        }
        <div className="select-features-w">
            <div className="title-f-games-r">
                <h2>Select Features</h2>
            </div>
            <div className="product-list-wrapper-t">
                {
                    Config.headerItems.map((item, i) => {
                        return item.enabled && !item.onlyInHeader && (item.iframeFullscreen
                            // eslint-disable-next-line react/jsx-no-bind
                        ? <div className={`product-item-v ${item.url}`} key={item.url} onClick={this.openPopupHandler(item.gameId)}>
                            {item.name}
                        </div>
                        : <Link key={i} className={`prod-column-t ${item.url}`} to={`/${item.url}?fromHomepage=1`} activeClassName="active">
                            {t(item.name)}
                        </Link>);
                    })
                }
            </div>
        </div>
        <div className="competitions-sports-w">
            <div className="title-f-games-r">
                <h2>Competitions</h2>
            </div>
            {
                !Config.enableFeaturedGamesInHome5 ? (Config.favoriteCompetitionsScroll
                ? <FavoriteCompetitionsSlider/> : <div className="competitions-list-h">
                    <FavoriteCompetitions fromHomePage={1}/> 
                </div> ): <div className="featured-games-w">
                    <MatchOfTheDayWrapper/>
                </div>
            }
        </div>
    </div>;
}